import axios from 'axios'
import qs from 'qs'
import { onRequest, onRequestError } from './interceptors/request'
import { onResponse, onResponseError } from './interceptors/response'

function createClient(baseUrl?: string) {
  const client = axios.create({
    baseURL: baseUrl,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  })

  client.interceptors.request.use(onRequest, onRequestError)
  client.interceptors.response.use(onResponse, onResponseError(client))

  return client
}

export { createClient }
